define("checkout/components/seamless-checkout", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{! NOTE: there should only be one of these inserted into the app }}
  {{#if this.showTrialPlansModal}}
    <SeamlessCheckout::TrialPlansModal />
  {{else if this.showCheckoutModal}}
    <SeamlessCheckout::CheckoutModal />
  {{else if this.showCheckoutSuccessModal}}
    <SeamlessCheckout::CheckoutSuccessModal />
  {{else if this.showNonAdminModal}}
    <SeamlessCheckout::NonAdminModal />
  {{/if}}
  {{! Future: feature highlight modal }}
  */
  {
    "id": "/Fj3khde",
    "block": "[[[41,[30,0,[\"showTrialPlansModal\"]],[[[1,\"  \"],[8,[39,1],null,null,null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showCheckoutModal\"]],[[[1,\"  \"],[8,[39,2],null,null,null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showCheckoutSuccessModal\"]],[[[1,\"  \"],[8,[39,3],null,null,null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showNonAdminModal\"]],[[[1,\"  \"],[8,[39,4],null,null,null],[1,\"\\n\"]],[]],null]],[]]]],[]]]],[]]]],[],false,[\"if\",\"seamless-checkout/trial-plans-modal\",\"seamless-checkout/checkout-modal\",\"seamless-checkout/checkout-success-modal\",\"seamless-checkout/non-admin-modal\"]]",
    "moduleName": "checkout/components/seamless-checkout.hbs",
    "isStrictMode": false
  });
  let SeamlessCheckoutComponent = _exports.default = (_class = class SeamlessCheckoutComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor, this);
    }
    get showNonAdminModal() {
      return this.seamlessCheckoutManager.showNonAdminModal;
    }
    get showCheckoutModal() {
      return this.seamlessCheckoutManager.showCheckoutModal;
    }
    get showTrialPlansModal() {
      return this.seamlessCheckoutManager.showTrialPlansModal;
    }
    get showCheckoutSuccessModal() {
      return this.seamlessCheckoutManager.showCheckoutSuccessModal;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SeamlessCheckoutComponent);
});